import { render, staticRenderFns } from "./ProductOrderForm.vue?vue&type=template&id=59d2c51e&scoped=true"
import script from "./ProductOrderForm.vue?vue&type=script&lang=ts"
export * from "./ProductOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./ProductOrderForm.vue?vue&type=style&index=0&id=59d2c51e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2c51e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59d2c51e')) {
      api.createRecord('59d2c51e', component.options)
    } else {
      api.reload('59d2c51e', component.options)
    }
    module.hot.accept("./ProductOrderForm.vue?vue&type=template&id=59d2c51e&scoped=true", function () {
      api.rerender('59d2c51e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refund-consign/components/ProductOrderForm.vue"
export default component.exports